import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'
import { Body } from './Body/Body'
import { Footer } from './Footer'
import { Header } from './Header'

export function Content() {
  const { ready } = useConfigureController()

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />} minWidth={960} maxWidth={1080}>
      <Body />
    </ModalContent>
  )
}
